import React, { Component } from "react";

import Comment from "./comment";
import CommentPost from "./comment_post";

import { setUserLocalStorage } from "../../helper/user_helper";
import {
  postComment,
  postCommentRecommendaton
} from "../../helper/comment_helper";

class CommentLine extends Component {
  state = {
    user: null,
    signedIn: false,
    loaded: true,
    comment: "",
    errors: ""
  };

  componentDidMount() {
    if (setUserLocalStorage().signedIn === true) {
      const userLocalStorage = setUserLocalStorage();
      const user = userLocalStorage.user;
      const signedIn = userLocalStorage.signedIn;
      this.setState({ user, signedIn });
    }
  }

  componentWillUnmount() {
    if (this.userCommentCall) {
      this.userCommentCall.cancel();
    }
  }

  render() {
    if (this.state.user === null) {
      // If user not login we don't let user ability to post
      return <div />;
    }
    if (this.props.question) {
      if (this.props.question.already_comment === true) {
        // If user not login we don't let user ability to post
        return <div />;
      }
    }

    return (
      <div className="row max_width_500 pb-2">
        <div className="width_image_question" />
        <div className="width_text_question width_text_align_answer">
          <Comment
            user={this.state.user}
            commentChanged={this.commentChanged}
            errors={this.state.errors}
            comment={this.state.comment}
          />
        </div>
        <div className="width_image_question">{this.renderUserImage()}</div>
      </div>
    );
  }

  renderUserImage() {
    return (
      <CommentPost
        bottomImage={true}
        handlerPostComment={this.handlerPostComment}
        loaded={this.state.loaded}
      />
    );
  }

  commentChanged = comment => {
    this.setState({ comment });
  };

  handlerPostComment = event => {
    event.preventDefault();
    const loaded = false;
    this.setState({ loaded });
    var fd = new FormData();

    if (this.props.question) {
      fd.append("answer[name]", this.state.comment);
      this.userCommentCall = postComment(this.props.question.id, fd);
    } else if (this.props.recommendation) {
      fd.append("comment[name]", this.state.comment);
      this.userCommentCall = postCommentRecommendaton(
        this.props.recommendation.id,
        fd
      );
    } else {
      return;
    }

    const self = this;
    this.userCommentCall.promise
      .then(res => {
        self.setState({
          answer: res.answer,
          loaded: true,
          errors: "",
          comment: ""
        });
        if (res.answer !== null) {
          self.props.addAnswer(res.answer);
        }
      })
      .catch(error => {
        self.setState({ errors: error.errors, loaded: true });
      });
  };
}

export default CommentLine;



// WEBPACK FOOTER //
// ./src/components/comments/comment_line.jsx